import React from "react";
import Label from "components/general/Label"
import { findArray, arraysEqual } from 'helpers/utils'
import { useViewport } from 'components/general/useViewPort'
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const HillData = ({ config }) => {
    const { breakPoint } = useViewport();
    const { mirs_discipline } = useUrlFriendlyToParameters()

    let hillSize,hillSize95,kPoint,metreValue,gateFactor,windFactorH,windFactorT = ''

    if(config !== undefined)
    {
        hillSize = config.extendedConfig ? findArray(config.extendedConfig, { code: ['HILL_SIZE'] })?.value : ''
        hillSize95 = config.extendedConfig ? findArray(config.extendedConfig, { code: ['HILL_SIZE_95'] })?.value : ''
        kPoint = config.extendedConfig ? findArray(config.extendedConfig, { code: ['K_POINT'] })?.value : ''
        metreValue = config.extendedConfig ? findArray(config.extendedConfig, { code: ['METRE_VALUE'] })?.value : ''
        gateFactor = config.extendedConfig ? findArray(config.extendedConfig, { code: ['GATE_FACTOR'] })?.value : ''
        windFactorH = config.extendedConfig ? findArray(config.extendedConfig, { code: ['WIND_FACTOR'], pos: ['H'] })?.value : ''
        windFactorT = config.extendedConfig ? findArray(config.extendedConfig, { code: ['WIND_FACTOR'], pos: ['T'] })?.value : ''
    }

    return (
        <table className="table">
            <thead>
                <tr>
                    <th className="text-start"><Label data="HeaderHillData" sport={mirs_discipline} /></th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <td className="fw-bold">
                        <Label data="LabelHillSize" sport={mirs_discipline} />&emsp;
                        {hillSize}m ({hillSize95}m)
                    </td>
                </tr>
                <tr>
                    <td className="fw-bold">
                        <Label data="LabelKPoint" sport={mirs_discipline} />&emsp;
                        {kPoint}m
                    </td>
                </tr>
                <tr>
                    <td className="fw-bold">
                        <Label data="LabelMetreValue" sport={mirs_discipline} />&emsp;
                        {metreValue} points per m
                    </td>
                </tr>
                <tr>
                    <td className="fw-bold">
                        <Label data="LabelGateFactor" sport={mirs_discipline} />&emsp;
                        {gateFactor} points per m
                    </td>
                </tr>
                <tr>
                    <td className="fw-bold">
                        <Label data="LabelWindFactor" sport={mirs_discipline} />&emsp;
                        {windFactorH} / {windFactorT} points per m/s
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default HillData;